import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpRequest } from "@/lib";
import { RequestFrequencyResponse } from "@/types";

export type UpdateFrequencyRequestDTO = {
  id: string;
  name: string;
  days: number;
};

async function updateFrequency(
  request: UpdateFrequencyRequestDTO
): Promise<RequestFrequencyResponse> {
  const { id, ...updateData } = request;

  const response = await httpRequest.put<RequestFrequencyResponse>(
    `/frequencies/${id}`,
    updateData
  );
  return response.data;
}

export function useUpdateFrequencyMutation() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: updateFrequency,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["frequencies"] });
    },
  });
}
